<iframe #frame title="Acompanhamento Integrações" src="https://app.powerbi.com/view?r=eyJrIjoiYTk4NzE0MGItNTU1YS00MTRiLWE2OTYtYTI0YzI1ZTIyNDU4IiwidCI6ImZkOTliM2EzLWUzODctNGE1MC05NTRhLTUzMDc5NGY5NWYwMCJ9" allowFullScreen="true"></iframe>
